import moment from 'moment';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ISelectItem } from '@cakeiteasy/web-ui';
import { FileUploadService } from '@cakeiteasy/web-utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  templateUrl: './import-reminders-modal.component.html',
  styleUrls: ['./import-reminders-modal.component.scss']
})
export class ImportRemindersModalComponent implements OnInit {
  @ViewChild('file', { static: false }) file: ElementRef;

  public reminderGroupId: number;
  public reminderReasons: ISelectItem[];
  public reason: ISelectItem;
  public remindersCount: number;
  public remindersErrors: any;
  public isFileError = signal(false);

  constructor(public modal: NgbActiveModal,
              private _translateService: TranslateService,
              private _uploadFile: FileUploadService) {
  }

  ngOnInit() {
    this.reason = this.reminderReasons[0];
  }

  public onFilesAdded() {
    this.init();

    this._uploadFile
      .importReminders(this.file.nativeElement.files[0], this.reminderGroupId, this.reason.value)
      .then((response) => {
        this.remindersCount = response.body.count;
        setTimeout(() => {
          this.modal.close();
        }, 2000);
      })
      .catch((err) => {
        if (isArray(err.error)) {
          this.remindersErrors = this._getError(err.error);
        } else {
          this.isFileError.set(true);
        }
      });
  }

  public addFiles() {
    this.file.nativeElement.click();
  }

  public init() {
    this.remindersCount = null;
    this.remindersErrors = null;
    this.isFileError.set(false);
  }

  public close() {
    if (this.remindersCount) {
      this.modal.close();
    } else {
      this.modal.dismiss();
    }
  }

  private _getError(error) {
    return error.map((e) => {
      const result = {};
      const isNameInvalid = isObject(e.person_name);
      const isDateInvalid = isObject(e.target_date);

      const personName = isNameInvalid ? e.person_name.value : e.person_name;
      const targetDate = isDateInvalid ? e.target_date.value : moment(e.target_date).format('DD/MM/YYYY');

      result['row'] = e.row_number;
      result['name'] = {
        value: personName,
        invalid: isNameInvalid
      };

      result['date'] = {
        value: targetDate,
        invalid: isDateInvalid
      };

      return result;
    });
  }
}
